module.exports = __webpack_public_path__ + "assets/b5e65e95b3dacabf6c3f05418c4d0d50.mp3";